/**
 * FirmaKullanicilarBolumu.jsx — Firma Detay › Profil & Belgeler › Kullanıcılar (2026-10-19)
 *
 * Firma Kartı'ndaki (firma tarafı) "Kullanıcılar" bölümünün denetmen karşılığı: firmaya bağlı girişler (user_to_firma) ve
 * başlıkta görünür bir "Kullanıcı ekle" düğmesi. Portal rolleri burada DEĞİL, Firma Detay › Portal Kullanıcıları'nda verilir.
 * Veri: portalRbacService.getFirmaKullanicilari (personel okuması, page.firma).
 */
import React, { useEffect, useState } from "react";
import { Alert, Badge, Card, CardBody, CardHeader, Spinner, Table } from "reactstrap";
import { useTranslation } from "react-i18next";
import { getFirmaKullanicilari } from "../../../../services/portalRbacService";
import KullaniciEkleDugmesi from "./KullaniciEkleDugmesi";

export default function FirmaKullanicilarBolumu({ firmaId, firmaAdi }) {
  const { t, i18n } = useTranslation("ayarlar");
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState(null);
  const [bilgi, setBilgi] = useState(null);
  const [yenile, setYenile] = useState(0);

  // KURAL: fetch Effect içindeki async fonksiyonda (react-hooks/set-state-in-effect); yazmadan sonra yeniden okuma `yenile` sayacıyla.
  useEffect(() => {
    let ignore = false;
    async function run() {
      try {
        const data = await getFirmaKullanicilari(firmaId);
        if (!ignore) { setVeri(data); setHata(null); }
      } catch (e) {
        if (!ignore) setHata(e.message || t("portalKullanicilari.okunamadi"));
      }
    }
    run();
    return () => { ignore = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firmaId, yenile, i18n.language]);

  return (
    <Card className="mb-3">
      <CardHeader className="bg-transparent d-flex align-items-center justify-content-between">
        <strong>{t("portalKullanicilari.firmaKullanicilari")}</strong>
        <KullaniciEkleDugmesi
          firmaId={firmaId} firmaAdi={firmaAdi}
          onEklendi={(kullanici) => {
            setBilgi(t("portalKullanicilari.eklendi", { kullanici, firma: firmaAdi || `#${firmaId}` }));
            setYenile((x) => x + 1);
          }}
        />
      </CardHeader>
      <CardBody>
        {hata && <Alert color="danger">{hata}</Alert>}
        {bilgi && <Alert color="success" toggle={() => setBilgi(null)}>{bilgi}</Alert>}
        {!veri && !hata && <div className="text-center py-4"><Spinner color="primary" size="sm" /></div>}
        {veri && (
          <div className="table-responsive">
            <Table className="align-middle mb-0" size="sm" data-testid="firma-kullanicilar-tablo">
              <thead className="table-light">
                <tr>
                  <th>{t("portalKullanicilari.giris")}</th>
                  <th>{t("portalKullanicilari.grup")}</th>
                  <th className="text-center">{t("portalKullanicilari.durum")}</th>
                </tr>
              </thead>
              <tbody>
                {veri.kullanicilar.length === 0 && (
                  <tr><td colSpan={3} className="text-center text-muted py-3">{t("portalKullanicilari.bos")}</td></tr>
                )}
                {veri.kullanicilar.map((k) => (
                  <tr key={k.userId} data-kullanici={k.loginAdi}>
                    <td>
                      <div className="fw-semibold">{[k.ad, k.soyad].filter(Boolean).join(" ") || k.loginAdi}</div>
                      <div className="small text-muted font-monospace">{k.loginAdi} · #{k.userId}</div>
                    </td>
                    <td className="small">
                      {k.userGroupAdi}
                      {k.personel && <Badge color="dark" className="ms-1">{t("portalKullanicilari.kaynakAd.PERSONEL")}</Badge>}
                    </td>
                    <td className="text-center">
                      <Badge color={k.aktif ? "success" : "secondary"} pill>{k.aktif ? t("portalKullanicilari.aktif") : t("portalKullanicilari.pasif")}</Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
